/**
 * Fetch word categories and word items from Supabase. Used by WordsScreen and WordsDetailScreen.
 */
import { supabase } from '../supabase';

export interface WordCategoryRow {
  slug: string;
  title_it: string;
  title_bn: string;
  title_en: string;
  icon?: string;
  color?: string;
  sort_order: number;
}

export interface WordItemRow {
  id: string;
  italian: string;
  bengali: string;
  icon?: string;
  color?: string;
}

export async function fetchWordCategories(): Promise<WordCategoryRow[] | null> {
  try {
    const { data, error } = await supabase
      .from('word_categories')
      .select('slug, title_italian, title_bengali, title_english, icon, color, sort_order')
      .order('sort_order');
    if (error) return null;
    return (data || []).map((row: Record<string, unknown>) => ({
      slug: row.slug,
      title_it: row.title_italian ?? row.title_it,
      title_bn: row.title_bengali ?? row.title_bn,
      title_en: row.title_english ?? row.title_en,
      icon: row.icon,
      color: row.color,
      sort_order: row.sort_order ?? 0,
    })) as WordCategoryRow[];
  } catch {
    return null;
  }
}

export async function fetchWordItemsByCategory(categorySlug: string): Promise<WordItemRow[] | null> {
  try {
    const { data, error } = await supabase
      .from('word_items')
      .select('id, italian, bengali, icon, color')
      .eq('category_slug', categorySlug)
      .order('sort_order');
    if (error) return null;
    return data || [];
  } catch {
    return null;
  }
}
